import React from "react";
import { useI18n } from "@/i18n";
import { Button } from "@/components/ui/button";

export function LangToggle() {
  const { lang, setLang } = useI18n();
  return (
    <div className="inline-flex items-center rounded-full border border-border bg-card/60 backdrop-blur p-1 text-xs font-semibold tracking-[0.2em]">
      <button
        data-testid="lang-toggle-de"
        onClick={() => setLang("de")}
        className={`px-3 py-1 rounded-full transition-colors ${lang === "de" ? "bg-primary text-primary-foreground" : "text-muted-foreground"}`}>
        DE
      </button>
      <button
        data-testid="lang-toggle-en"
        onClick={() => setLang("en")}
        className={`px-3 py-1 rounded-full transition-colors ${lang === "en" ? "bg-primary text-primary-foreground" : "text-muted-foreground"}`}>
        EN
      </button>
    </div>
  );
}

export function Brand({ onAdminClick }) {
  const { t } = useI18n();
  return (
    <header className="sticky top-0 z-40 border-b border-border/60 glass">
      <div className="mx-auto max-w-7xl flex items-center justify-between px-6 py-4">
        <a href="/" className="flex items-center gap-3" data-testid="brand-home">
          <img src="/assets/logo.png" alt="ERP Institute" className="h-11 md:h-12 w-auto" />
          <div className="leading-tight sr-only">
            <div className="text-sm font-semibold">{t("brand")}</div>
            <div className="text-[10px] uppercase tracking-[0.24em] text-muted-foreground">{t("subbrand")}</div>
          </div>
        </a>
        <div className="flex items-center gap-3">
          <LangToggle />
        </div>
      </div>
    </header>
  );
}
